import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import ajaxCard from "../../util/remote/ajaxCard";


const MarkCardAsLost=(props)=>{

    const [loading, setLoading] = useState(false)
    const [reason, setReason] = useState("")

    const data = {
        card_id: props.cardID,
        reason: reason
      };

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if (!reason || reason.trim() === "") {
            toast.error("Please provide a reason");
            return;
        }
        setLoading(true)
        const server_response = await ajaxCard.markCardAsLost(data);
        setLoading(false);
        if(server_response.status==="OK"){
            toast.success(server_response.message);
            props.getAllCards(props.page);
            props.getAssignedCards(props.assignedPage);
            props.getInactiveCards(props.inactivePage);
            props.getUnassignedCards(props.unassignedPage);
            props.countAssignedCards()
            props.countAssignedWristbands()
        }
        else{
            toast.error(server_response.message); 
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Confirm<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Report Lost Card / Wristband"
            id="model-card-lost"
            size="md"
            footer={RenderFooter}
        >

        <div className="mb-4 form-group border-1">
            <label htmlFor="">Reason:<span style={{color:"red"}}>*</span> </label>
            <input onChange={(e)=>setReason(e.target.value)} placeholder="Provide a reason..." style={{border: "1px solid grey"}} value={reason} type="text" className="form-control"/>
        </div>
       
        </SystemModal>
    )
}

export default MarkCardAsLost
